export default __webpack_public_path__ + "static/cancel-process-13dc7ac4b4b4edf9e41cfd571dab2560.svg";